<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>{{ $t('Portfolio At Risk Summary') }}</b-card-title>
      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchPARFormulae"
      />
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="(parFormulae, index) in PARFormulae"
          :key="index"
          xl="2"
          sm="6"
          class="mb-1"
        >
          <h5 class="font-weight-bolder mb-0 text-wrap">
            {{ parFormulae.amount }}
          </h5>
          <b-card-text class="font-small-5 mb-0">
            {{ parFormulae.par }}
          </b-card-text>
        </b-col>
      </b-row>
    </b-card-body>
    <Spinner :show="isLoadingPARFormulae" />
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import { toBalance } from '@/helpers/formatAmount'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    Spinner,
  },
  setup() {
    const { getPARFormulaeAction } = useActions({ getPARFormulaeAction: 'dashboard/getPARFormulaeSummaryAction' })
    const { toastAlert } = useToastAlert()
    const PARFormulae = ref([])
    const isLoadingPARFormulae = ref(false)
    const fetchPARFormulae = async () => {
      try {
        isLoadingPARFormulae.value = true
        const response = await getPARFormulaeAction()
        const { status, data } = response
        if (status === 200 && data) {
          PARFormulae.value = data.summary.map(item => ({
            ...item,
            amount: `${item.amount.toFixed(2)}%`,
          }))
          isLoadingPARFormulae.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingPARFormulae.value = false
      }
    }
    onMounted(async () => {
      await fetchPARFormulae()
    })
    return {
      PARFormulae,
      fetchPARFormulae,
      isLoadingPARFormulae,
      toBalance,
    }
  },
}
</script>
